<template>
  <base-popup
      :popup-model="show"
      :title="formTitle"
      :valid="!valid"
      @onCancelButtonClick="closePopupHandler"
      @onSaveButtonClick="saveItemHandler"
  >
    <v-form
        :ref="formRef"
        v-model="valid"
        lazy-validation
    >
      <v-container>
        <v-layout>
          <v-flex xs12>
            <v-text-field
                v-model="currentItem.name"
                :rules="requiredFieldRule"
                label="Name"
                prepend-icon="create"
                required
            />
            <v-text-field
                v-model.number="currentItem.price"
                :rules="numberRule"
                class="right-align-text"
                label="Price"
                onclick="this.select()"
                prepend-icon="attach_money"
                required
                type="number"
            />
            <v-layout class="custom-switch-btn" row>
              <v-flex xs3>
                <v-subheader class="switch-btn-title">Status</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-switch
                    v-model="currentItem.isActive"
                    color="primary"
                    dense
                    inset
                    prefix="Status">
                </v-switch>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </base-popup>
</template>
<script>
import BasePopup from "./BasePopup";
import PopupMixin from "../mixins/Popup";

export default {
  name: 'ExtraFacilityPopup',
  components: {BasePopup},
  mixins: [PopupMixin],
  computed: {
    formTitle() {
      return this.isEditMode
          ? 'Edit Extra Facility'
          : 'Add Extra Facility'
    }
  }
}
</script>
